"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FabricDataMap = /** @class */ (function () {
    function FabricDataMap() {
        this.fabricData = [];
        this.rotationArray = [];
        this.existingPages = [];
    }
    FabricDataMap.prototype.reset = function () {
        this.fabricData = [];
        this.rotationArray = [];
        this.existingPages = [];
    };
    /**
     *
     * @param pageNumber from 1 onwards
     */
    FabricDataMap.prototype.getFabricData = function (pageNumber) {
        return this.fabricData[pageNumber - 1];
    };
    FabricDataMap.prototype.setFabricData = function (pageNumber, data) {
        this.fabricData[pageNumber - 1] = data;
    };
    FabricDataMap.prototype.initWithJSON = function (fabricDataMapJSON) {
        var _this = this;
        this.reset();
        if (!fabricDataMapJSON || fabricDataMapJSON === '')
            return;
        var fabricDataMapParsed = JSON.parse(fabricDataMapJSON);
        if (fabricDataMapParsed.fabricData) {
            this.fabricData = fabricDataMapParsed.fabricData;
        }
        if (fabricDataMapParsed.rotationArray) {
            this.rotationArray = fabricDataMapParsed.rotationArray;
        }
        if (fabricDataMapParsed.existingPages) {
            this.existingPages = fabricDataMapParsed.existingPages;
        }
        if (fabricDataMapParsed.version) {
            this.version = fabricDataMapParsed.version;
        }
        // Fix rotationArray values. The correct source is the rotate property in fabricData.
        this.fabricData.forEach(function (fabricDataEntry, index) {
            // fabricDataEntry may be null if the page is advance before the editor is activated.
            // Upload a pdf file. Go to next pages and rotate the pages. Show editor.
            if (fabricDataEntry && fabricDataEntry.rotate !== _this.rotationArray[index]) {
                _this.rotationArray[index] = fabricDataEntry.rotate;
            }
        });
    };
    return FabricDataMap;
}());
exports.FabricDataMap = FabricDataMap;
//# sourceMappingURL=FabricDataMap.js.map